import { useCallback } from 'react';
import moment from 'moment-timezone';

import useRequestJSON from './hooks/useRequestJSON';
import { BaseResponse, PostJSON } from './request';
import { GetCurrentTZ } from './time';

export interface PatientParams {
  patient: number;
}

interface SummaryData<T> {
  data: T;
  isLoading: boolean;
}

const GetSummary = <P extends PatientParams>(url: string, params: P) =>
  PostJSON({
    url: url,
    params: {
      start: moment().subtract(2, 'weeks').startOf('day').format(),
      end: moment().endOf('day').format(),
      tz: GetCurrentTZ(),
      patient: params.patient,
      ...params
    }
  });

const transformSummary = <T>(response: BaseResponse & T) => {
  const { status: _status, ...data } = response as BaseResponse;
  return data as T;
};

export const useGetSummary = <T, P extends PatientParams = PatientParams>(
  url: string,
  params: P
): SummaryData<T> => {
  const request = useCallback(() => GetSummary(url, params), [params.patient]);
  const { data, isLoading } = useRequestJSON<BaseResponse & T, T>({
    request,
    transformFn: transformSummary,
    enabled: params?.patient != null
  });
  return { data, isLoading };
};
